import type { LocalStorageFunctions, LocalLeftMenuState } from './types';

const LEFT_MENU_STATE: string = 'left-menu-state-closed';

const getLocalStorageLeftMenuState = (fn: LocalStorageFunctions) => (): boolean => !!fn.readObject<boolean>(LEFT_MENU_STATE);
const setLocalStorageLeftMenuState= (fn: LocalStorageFunctions) => (isClosed: boolean) => fn.writeObject(LEFT_MENU_STATE, isClosed);

const leftMenuState = (fn: LocalStorageFunctions): LocalLeftMenuState => ({
  getLocalStorageLeftMenuState: getLocalStorageLeftMenuState(fn),
  setLocalStorageLeftMenuState: setLocalStorageLeftMenuState(fn)
});

export default leftMenuState;
